import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ResultForm from './resultForms/ResultForm';
import AdvancedSearchResults from './results/AdvancedSearchResults';
import {
  resetAdvancedSearch,
  searchAdvancedFilings,
  setFormFilter,
} from '../../redux/actions/advancedSearchAction';

export class AdvancedSearchTab extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const {
      tab,
      courtType,
      queryParams,
      history,
      onSetFormFilter,
    } = this.props;

    onSetFormFilter({ courtType, tab, queryParams, history });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const {
      tab,
      courtType,
      queryParams,
      history,
      onSetFormFilter,
    } = this.props;

    if (tab !== prevProps.tab || courtType !== prevProps.courtType) {
      onSetFormFilter({ courtType, tab, queryParams, history });
    }
  }

  render() {
    const { filter, showResults, onAdvancedSearch, onReset, InitialForm } = this.props;

    return showResults
      ? (
        <section className="advanced-search-tab">
          <ResultForm
            filter={filter}
            onSubmit={onAdvancedSearch}
            onReset={onReset}
          />
          <AdvancedSearchResults/>
        </section>
      ) : (
        <section className="advanced-search-tab">
          <InitialForm filter={filter} onSubmit={onAdvancedSearch} onReset={onReset}/>
        </section>
      );
  };
}

AdvancedSearchTab.propTypes = {
  filter: PropTypes.any,
  onReset: PropTypes.func.isRequired,
  onAdvancedSearch: PropTypes.func.isRequired,
};

AdvancedSearchTab.defaultProps = {
  filter: {},
};

const mapStateToProps = state => ({ ...state.get('advancedSearch').toJS() });

const mapDispatchToProps = {
  onReset: resetAdvancedSearch,
  onAdvancedSearch: searchAdvancedFilings,
  onSetFormFilter: setFormFilter,
};

export default connect(mapStateToProps, mapDispatchToProps)(AdvancedSearchTab);



// WEBPACK FOOTER //
// ./src/components/advancedSearch/AdvancedSearchTab.jsx